import Helmet from 'react-helmet';

interface Props {
  title: string;
}

export const PageTitle = (props: Props) => {
  const title = `${props.title} - Tandemz`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
    </Helmet>
  );
};
